export const dark = {
  fds: {
    primary: "#202123",
    secondary: { DEFAULT: "#313336", hover: "#404347", select: "#52565c" },
    tertiary: { DEFAULT: "#404347", hover: "#404347", select: "#6a6e75" },
    disable: "#313336",
    inverse: {
      primary: "#ffffff",
      secondary: "#f1f2f2",
      tertiary: "#E4E5E7",
    },
    brand: {
      DEFAULT: "#3064c0",
      hover: "#5983cd",
      select: "#7497d5",
      disabled: "#224788",
      light: {
        DEFAULT: "#0F203D",
        hover: "#142a51",
        select: "#1a376a",
      },
    },
    accent: {
      DEFAULT: "#057c82",
      hover: "#37969b",
      select: "#58a7ab",
      light: {
        DEFAULT: "#012527",
        hover: "#023437",
        select: "#034448",
      },
    },
    danger: {
      DEFAULT: "#d22d3d",
      hover: "#db5764",
      select: "#e1727d",
      light: {
        DEFAULT: "#3B0D11",
        hover: "#58131a",
        select: "#741922",
      },
    },
    success: {
      DEFAULT: "#278062",
      hover: "#529981",
      select: "#6eaa96",
      light: {
        DEFAULT: "#0C271E",
        hover: "#103629",
        select: "#154636",
      },
    },
    warning: {
      DEFAULT: "#ffb52b",
      hover: "#ffc455",
      select: "#ffcd71",
      light: {
        DEFAULT: "#412F0B",
        hover: "#6b4c12",
        select: "#8c6418",
      },
    },
    info: {
      DEFAULT: "#0c68f4",
      hover: "#3d86f6",
      select: "#5c9af8",
      light: {
        DEFAULT: "#041F49",
        hover: "#052c66",
        select: "#073986",
      },
    },
    overlay: {
      black: "#202123",
      white: "#ffffff",
    },
    always: {
      black: "#202123",
      grey: "#6e798d",
      white: "#ffffff",
    },
  },
};

export const light = {
  fds: {
    primary: "#ffffff",
    secondary: { DEFAULT: "#f1f2f2", hover: "#d4d5d8", select: "#bfc1c5" },
    tertiary: { DEFAULT: "#d4d5d8", hover: "#bfc1c5", select: "#a2a5ab" },
    disable: "#E4E5E7",
    "inverse-primary": "#202123",
    "inverse-secondary": "#313336",
    "inverse-tertiary": "#404347",
    brand: {
      DEFAULT: "#3064c0",
      hover: "#2c5baf",
      select: "#224788",
      disabled: "#7497d5",
      light: {
        DEFAULT: "#EAF0F9",
        hover: "#bfcfeb",
        select: "#a0b8e2",
      },
    },
    accent: {
      DEFAULT: "#057c82",
      hover: "#057176",
      select: "#04585c",
      light: {
        DEFAULT: "#e6f2f3",
        hover: "#b2d6d8",
        select: "#8cc3c6",
      },
    },
    danger: {
      DEFAULT: "#d22d3d",
      hover: "#bf2938",
      select: "#95202b",
      light: {
        DEFAULT: "#F8DDE0",
        hover: "#f1bec3",
        select: "#ea9ea6",
      },
    },
    success: {
      DEFAULT: "#278062",
      hover: "#237459",
      select: "#1c5b46",
      light: {
        DEFAULT: "#e9f2ef",
        hover: "#bcd8ce",
        select: "#9cc5b7",
      },
    },
    warning: {
      DEFAULT: "#ffb52b",
      hover: "#e8a527",
      select: "#b5811f",
      light: {
        DEFAULT: "#FFF3DB",
        hover: "#ffe8bd",
        select: "#ffcd71",
      },
    },
    info: {
      DEFAULT: "#0c68f4",
      hover: "#0b5fde",
      select: "#094aad",
      light: {
        DEFAULT: "#e7f0fe",
        hover: "#b4d0fc",
        select: "#8fbafa",
      },
    },
    overlay: {
      black: "#202123",
      white: "#ffffff",
    },
    always: {
      black: "#202123",
      grey: "#6e798d",
      white: "#ffffff",
    },
  },
};

export const backgroundColor = {
  light,
  dark,
  ...light,
};
